import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { HasProduct, HasProductContext, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import clearForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm";
import setProduct from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { AvailabilityDto, AvailabilityMessageType } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Check from "@insite/mobius/Icons/Check";
import X from "@insite/mobius/Icons/X";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomContactUsForm from "@tCooneyBrothers/Components/CustomContactUsForm";
import ProductAvailability from "@tCooneyBrothers/Overrides/Components/ProductAvailability";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

type OwnProps = {
    onClick?: React.EventHandler<React.MouseEvent>;
} & WidgetProps &
    HasProduct &
    HasProductContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;
const mapDispatchToProps = {
    setProduct,
};
const mapStateToProps = (state: ApplicationState, props: HasProduct) => {
    return {
        state,
        replacedProductInventory: state.components.productSelector.selectedProductInfo?.inventory,
        productSettings: getSettingsCollection(state).productSettings,
        showInventory: state.context.showInventory,
        selectProductInfo: state.components.productSelector.selectedProductInfo,
    };
};

export interface ProductDetailReplacementStyles {
    wrapper?: InjectableCss;
    descriptionGridItem?: GridItemProps;
    partNumbersGridItem?: GridItemProps;
    productAvailibility?: GridItemProps;
    leftContainer?: GridContainerProps;
    rightContainer?: GridContainerProps;
    discontinuedTitleGridItem?: GridItemProps;
    discontinuedGridItem?: GridItemProps;
    leftGridItem?: GridItemProps;
    rightGridItem?: GridItemProps;
    replacementMssgGridItem?: GridItemProps;
    replaceImageGridMobile?: GridItemProps;
    replaceImageGridDesktop?: GridItemProps;
    commonGrid?: GridItemProps;
    replacementGridItem?: GridItemProps;
    requestReplacementGridItem?: GridItemProps;
    replaceProductInfo?: GridItemProps;
    titleReplacement?: InjectableCss;
    replacementText?: InjectableCss;
    replacementProductImage?: InjectableCss;
    replacementProductImageDesktop?: InjectableCss;
    descriptionStyles?: ProductDescriptionStyles;
    partNumbersStyles?: ProductPartNumbersStyles;
    messageText?: TypographyPresentationProps;
    replacementTextMssg?: TypographyPresentationProps;
    inventoryMessage?: InjectableCss;
    availiblityWrapper?: InjectableCss;
    productDetailDescription?: TypographyProps;
    replacementProductLink?: LinkPresentationProps;
    viewReplacementBtn?: ButtonPresentationProps;
    discontinuedImage?: LazyImageProps;
    rightGridItemMobile?: GridItemProps;
    rightGridItemDesktop?: GridItemProps;
    replaceMentMssgGridItemDesktop?: GridItemProps;
    replacementProduct?: GridContainerProps;
    replacementProductInfo?: GridItemProps;
    replacementProductGridItem?: GridItemProps;
    replacementProductButtonGridItem: GridItemProps;
    rfqButton: ButtonPresentationProps;
    successModal?: ModalPresentationProps;
    modalContainer?: GridContainerProps;
    messageTextGridItem?: GridItemProps;
}
const availabilityStyles: ProductAvailabilityStyles = {};

export const addToListLinkStyles: ProductDetailReplacementStyles = {
    wrapper: {
        css: css`
            margin-top: 30px;
            text-align: center;
            padding: 15px;
        `,
    },
    leftContainer: {
        gap: 10,
    },
    leftGridItem: {
        width: [12, 12, 3, 3, 3],
        css: css`
            padding: 0px;
        `,
    },
    rightGridItemMobile: {
        width: [12, 12, 12, 8, 8],
        css: css`
            padding: 0px;
            position: relative;
            height: auto;
            border: 2px solid #950001;
            background-color: #f4f4f4;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            height: auto;
                            flex-direction: column;
                            padding: 0px;
                        `,
                        css`
                            height: auto;
                            flex-direction: column;
                            padding: 0px;
                        `,
                        css`
                            height: auto;
                            padding: 0px;
                        `,
                        css`
                            height: auto;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    rightGridItem: {
        width: [12, 12, 12, 8, 8],
        css: css`
            padding: 0px;
            position: relative;
            height: auto;
            border: 2px solid #950001;
            background-color: #f4f4f4;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            height: auto;
                            padding-left: 0;
                        `,
                        css`
                            height: auto;
                            padding-left: 0;
                        `,
                        css`
                            height: auto;
                            padding-left: 0;
                        `,
                        css`
                            height: auto;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    replacementMssgGridItem: {
        width: [12, 12, 12, 8, 8],
        css: css`
            padding: 0px;
            position: relative;
            height: auto;
            border: 2px solid #950001;
            background-color: #f4f4f4;
            div[class^="HiddenStyle"] {
                height: 100%;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            height: auto;
                            padding-left: 0;
                        `,
                        css`
                            height: auto;
                            padding-left: 0;
                        `,
                        css`
                            height: auto;
                            padding-left: 0;
                        `,
                        css`
                            height: auto;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    rightGridItemDesktop: {
        width: [12, 12, 12, 8, 8],
        css: css`
            padding: 0 0 0 0px;
            position: relative;
            height: auto;
            border: 2px solid #950001;
            background-color: #f4f4f4;
            max-width: 100% !important;
            div[class^="replaceImageGrid"] {
                margin-left: 40px;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-left: 0;
                            height: auto;
                        `,
                        css`
                            padding-left: 0;
                            height: auto;
                        `,
                        css`
                            padding-left: 20px;
                            height: auto;
                        `,
                        css`
                            height: auto;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    replaceMentMssgGridItemDesktop: {
        width: [12, 12, 12, 8, 8],
        css: css`
            padding: 0 0 0 0px;
            position: relative;
            height: 100%;
            border: 2px solid #950001;
            background-color: #f4f4f4;
            max-width: 100% !important;
            div[class^="replaceImageGrid"] {
                margin-left: 40px;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-left: 0;
                            height: auto;
                        `,
                        css`
                            padding-left: 0;
                            height: auto;
                        `,
                        css`
                            padding-left: 20px;
                            height: auto;
                        `,
                        css`
                            height: auto;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    replacementGridItem: {
        width: [1, 1, 1, 1, 1],
        css: css`
            height: 100%;
            position: relative;
            padding: 0px;
        `,
    },
    requestReplacementGridItem: {
        width: [1, 1, 1, 1, 1],
        css: css`
            height: 100%;
            position: relative;
            padding: 0px;
            flex-basis: 6.33% !important;
            max-width: 6.33% !important;
        `,
    },
    discontinuedGridItem: {
        width: 12,
        css: css`
            padding: 0px;
        `,
    },
    discontinuedTitleGridItem: {
        width: 12,
    },
    titleReplacement: {
        css: css`
            width: 100%;
            text-align: left;
            font-weight: bold;
            font-size: 16px;
            padding: 10px;
        `,
    },
    replacementText: {
        css: css`
            z-index: 99;
            color: #ffffff;
            background-color: #950001;
            text-align: center;
            font-weight: bold;
            font-size: 16px;
            padding: 5px;
            height: auto;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            width: 28px;
            transform: rotate(-180deg);
            writing-mode: tb-rl;
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },
    replacementProductImage: {
        css: css`
            height: auto;
            margin: 13px -10px;
            background-color: #ffffff;
            border: 1px solid #cccccc;
            img {
                max-width: 100%;
                max-height: 100%;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            height: auto;
                            margin: 23px 13px;
                        `,
                        css`
                            height: auto;
                            margin: 23px 13px;
                        `,
                        css`
                            height: auto;
                            margin: 23px 13px;
                        `,
                        css`
                            height: auto;
                            margin: 23px 13px;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    replacementProductImageDesktop: {
        css: css`
            width: 145px;
            height: 140px;
            margin: 13px -10px;
            background-color: #ffffff;
            border: 1px solid #cccccc;
            img {
                max-width: 100%;
                max-height: 100%;
            }
            > div[class^="LazyImageStyle"] {
                width: 140px;
            }
        `,
    },
    descriptionGridItem: {
        width: 12,
        css: css`
            padding: 5px 15px 5px 20px;
        `,
    },
    partNumbersGridItem: {
        width: 12,
        css: css`
            padding: 5px 0 0 20px;
        `,
    },
    productAvailibility: {
        width: 12,
        css: css`
            padding: 10px 0 0 20px;
        `,
    },
    replaceImageGridMobile: {
        width: [12, 12, 12, 6, 2],
        css: css`
            padding: 0px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin: 0 auto !important;
                            padding: 0px 0px 0px 18px;
                        `,
                        css`
                            margin: 0 auto !important;
                            padding: 0px 0px 0px 18px;
                        `,
                        css`
                            margin: 0 auto !important;
                            flex-basis: 28.666667%;
                        `,
                        css`
                            margin: 0 auto !important;
                            flex-basis: 28.666667%;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    replaceImageGridDesktop: {
        width: [12, 12, 12, 6, 2],
        css: css`
            padding: 0px;
            margin: 0 auto !important;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin: 0 auto !important;
                            padding: 0px 0px 0px 18px;
                        `,
                        css`
                            margin: 0 auto !important;
                            padding: 0px 0px 0px 18px;
                        `,
                        css`
                            margin: 0 auto !important;
                            flex-basis: 28.666667%;
                        `,
                        css`
                            margin-left: 35px !important;
                            flex-basis: 28.666667%;
                        `,
                        css`
                            margin: 0 auto !important;
                            flex-basis: 28.666667%;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    messageText: {
        css: css`
            width: 100%;
            text-transform: capitalize;
            font-weight: 600;
            align-self: baseline;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 11px;
                        `,
                        css`
                            font-size: 11px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    replacementTextMssg: {
        css: css`
            width: 100%;
            font-weight: 600;
            align-self: baseline;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 11px;
                        `,
                        css`
                            font-size: 11px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    replaceProductInfo: {
        width: [12, 12, 9, 9, 9],
        css: css`
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            text-align: left;
        `,
    },
    replacementProductInfo: {
        width: [12, 12, 12, 12, 12],
        css: css`
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            text-align: left;
        `,
    },
    productDetailDescription: {
        css: css`
            word-break: break-word;
            font-weight: bold;
        `,
    },
    replacementProductLink: {
        css: css`
            width: 100%;
            margin: 0 auto;
        `,
        typographyProps: {
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
            `,
        },
    },
    viewReplacementBtn: {
        css: css`
            cursor: pointer;
            font-family: inherit;
            min-height: 32px;
            line-height: 1;
            backface-visibility: hidden;
            word-break: keep-all;
            padding: 0px 21px;
            background: rgb(88, 180, 108);
            border: 2px solid rgb(88, 180, 108);
            color: #141414;
            width: 100%;
            margin: 0 auto;
            &:hover {
                background: rgb(88, 180, 108);
                border: 2px solid rgb(88, 180, 108);
            }
        `,
    },
    rfqButton: {
        css: css`
            cursor: pointer;
            background: rgb(88, 180, 108);
            border: 2px solid rgb(88, 180, 108);
            color: #141414;
            padding: 0 25px;
            &:hover {
                background: rgb(88, 180, 108);
                border: 2px solid rgb(88, 180, 108);
            }
        `,
    },
    commonGrid: {
        width: [12, 12, 12, 12, 6],
        css: css`
            padding: 0px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 50%;
                    `,
                    css`
                        flex-basis: 50%;
                    `,
                    css`
                        flex-basis: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                    `,
                ]);
            }}
        `,
    },
    replacementProductGridItem: {
        width: [12, 12, 12, 12, 12],
    },
    replacementProductButtonGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            justify-content: flex-end;
            padding: 8px;
        `,
    },
    availiblityWrapper: {
        css: css`
            padding-bottom: 5px;
        `,
    },
    discontinuedImage: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin: 0 auto;
                        `,
                        css`
                            margin: 0 auto;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    replacementProduct: {
        offsetCss: css`
            flex-direction: column;
            gap: 5px;
        `,
    },
    successModal: {
        sizeVariant: "small",
        cssOverrides: {
            modalTitle: css`
                padding: 10px 20px;
                border-bottom: 3px solid #ef3742;
                background: #fafafa;
            `,
            modalContent: css`
                padding: 30px;
                padding-top: 0;
            `,
            modalBody: css`
                max-height: calc(100% - 40px) !important;
            `,
        },
    },
    messageTextGridItem: {
        width: 12,
        css: css`
            padding-top: 25px;
            padding-bottom: 0;
        `,
    },
};

const InventoryMessage = styled.div<{ color: string }>`
    display: flex;
    align-items: center;
    padding: 5px 10px 5px 5px;
    border-radius: 5px;
    background-color: #d2ebd7;
    max-height: 29px;
    border: 2px solid #58b46c;
    ${IconWrapper} {
        margin-right: 10px;
        color: #58b46c;
    }
`;

const getAvailabilityColor = (availability?: AvailabilityDto) => {
    let color = "success";
    if (!availability) {
        return color;
    }
    const availabilityType = availability.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        color = "danger";
    } else if (availabilityType === AvailabilityMessageType.LowStock) {
        color = "warning";
    }
    return color;
};

const getAvailabilityIcon = (availability?: AvailabilityDto) => {
    let iconSrc = Check;
    if (!availability) {
        return iconSrc;
    }
    const availabilityType = availability.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        iconSrc = X;
    } else if (availabilityType === AvailabilityMessageType.LowStock) {
        iconSrc = AlertTriangle;
    }
    return iconSrc;
};

const ProductDetailReplacement: React.FC<OwnProps> = ({
    state,
    product,
    onClick,
    setProduct,
    replacedProductInventory,
    selectProductInfo,
    productContext,
}) => {
    const [styles] = React.useState(() => mergeToNew(addToListLinkStyles, availabilityStyles));
    let replaceProduct = null;
    if (product?.detail?.replacementProductId) {
        replaceProduct = state.data.products.byId[product.detail?.replacementProductId];
    }
    const availability = replacedProductInventory?.inventoryAvailabilityDtos
        ? replacedProductInventory?.inventoryAvailabilityDtos[0]?.availability
        : null;
    const productTitle = product.productTitle;
    const productNumber = product.productNumber;
    const brandName = product.brand?.name;
    const showDiscontinuedTag = product.properties?.discontinuedProduct?.toLowerCase() === "true" || false;
    const requestForReplacement = product.properties?.requestForReplacement?.toLowerCase() === "true" || false;
    const color = availability && getAvailabilityColor(availability);
    const iconSrc = availability && getAvailabilityIcon(availability);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    if (!showDiscontinuedTag) {
        return null;
    }
    React.useEffect(() => {
        if (product && product.detail?.replacementProductId) {
            setProduct({
                productId: product.detail?.replacementProductId,
            });
        }
    }, []);

    const imagePath = replaceProduct?.smallImagePath || replaceProduct?.mediumImagePath;
    const imageAltText = replaceProduct
        ? replaceProduct?.images && replaceProduct?.images?.length > 0
            ? replaceProduct?.images[0]?.imageAltText
            : `${replaceProduct?.brand?.name} ${replaceProduct?.brand?.name} ${replaceProduct?.manufacturerItem}`
        : "";
    const description = replaceProduct?.productTitle;
    const productDetailPath = replaceProduct?.urlSegment;
    const onButtonClickHandler = () => {
        setIsModalOpen(true);
    };
    const contactUsModalCloseHandler = () => setIsModalOpen(false);
    const continueButtonClickHandlerToParent = (modalState: boolean) => {
        modalState = false;
        setIsModalOpen(modalState);
        clearForm();
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <GridContainer>
                <GridItem {...styles.leftGridItem}>
                    <GridContainer {...styles.leftContainer}>
                        <GridItem {...styles.discontinuedGridItem}>
                            <LazyImage src="/UserFiles/Images/discontinued-sm.png" />
                        </GridItem>
                        {product && (
                            <GridItem {...styles.discontinuedTitleGridItem}>
                                {product && (
                                    <StyledWrapper {...styles.titleReplacement}>
                                        {`${product?.brand?.name} ${product.manufacturerItem} has been discontinued by the manufacturer.`}
                                    </StyledWrapper>
                                )}
                            </GridItem>
                        )}
                    </GridContainer>
                </GridItem>
                {!(!showDiscontinuedTag || !replaceProduct) ? (
                    <GridItem {...styles.rightGridItem} className="text-wrapper1">
                        <GridItem {...styles.replacementGridItem} className="text-wrapper2">
                            <StyledWrapper {...styles.replacementText} className="text-wrapper3">
                                {translate("REPLACEMENT")}
                            </StyledWrapper>
                        </GridItem>
                        <Hidden above="sm">
                            <GridItem {...styles.rightGridItemMobile} className="mobileItem">
                                <GridItem {...styles.replaceImageGridMobile}>
                                    <StyledWrapper {...styles.replacementProductImage} className="text-wrapper4">
                                        <LazyImage src={imagePath} altText={imageAltText} />
                                    </StyledWrapper>
                                </GridItem>
                                <GridItem {...styles.replaceProductInfo}>
                                    <GridItem {...styles.descriptionGridItem}>
                                        <Link
                                            {...styles.replacementProductLink}
                                            href={productDetailPath}
                                            onClick={onClick}
                                            data-test-selector="replacementProductLink"
                                        >
                                            <Typography as="h2" {...styles.productDetailDescription}>
                                                {description}
                                            </Typography>
                                        </Link>
                                    </GridItem>
                                    <GridItem {...styles.partNumbersGridItem}>
                                        {replaceProduct && (
                                            <ProductPartNumbers
                                                productNumber={replaceProduct.productNumber}
                                                customerProductNumber={replaceProduct.customerProductNumber}
                                                manufacturerItem={replaceProduct.manufacturerItem}
                                                extendedStyles={styles.partNumbersStyles}
                                            />
                                        )}
                                    </GridItem>
                                    <GridItem {...styles.productAvailibility}>
                                        <GridContainer gap={0}>
                                            <GridItem {...styles.commonGrid}>
                                                <StyledWrapper {...styles.availiblityWrapper} className="availibility">
                                                    {selectProductInfo && availability && replaceProduct && (
                                                        <ProductAvailability
                                                            productId={selectProductInfo?.productId}
                                                            quantity={selectProductInfo.qtyOrdered}
                                                            productTitle={replaceProduct.productTitle}
                                                            productNumber={replaceProduct.productNumber}
                                                            trackInventory={replaceProduct?.trackInventory}
                                                            availability={availability}
                                                            unitOfMeasure={selectProductInfo?.unitOfMeasure}
                                                            isProductDetailsPage={true}
                                                            failedToLoadInventory={
                                                                selectProductInfo.failedToLoadInventory
                                                            }
                                                        />
                                                    )}
                                                </StyledWrapper>
                                            </GridItem>
                                            <GridItem {...styles.commonGrid}>
                                                <StyledWrapper>
                                                    <Link
                                                        {...styles.replacementProductLink}
                                                        href={productDetailPath}
                                                        onClick={onClick}
                                                        data-test-selector="replacementProductLink"
                                                    >
                                                        <Button
                                                            {...styles.viewReplacementBtn}
                                                            id={`View-Replacement-${replaceProduct?.id}`}
                                                        >
                                                            {translate("View Replacment")}
                                                        </Button>
                                                    </Link>
                                                </StyledWrapper>
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridItem>
                            </GridItem>
                        </Hidden>
                        <Hidden below="md">
                            <GridItem {...styles.rightGridItemDesktop}>
                                <GridItem {...styles.replaceImageGridDesktop} className="replaceImageGrid">
                                    <StyledWrapper
                                        {...styles.replacementProductImageDesktop}
                                        className="replacementProductImageDesktop"
                                    >
                                        <LazyImage src={imagePath} altText={imageAltText} />
                                    </StyledWrapper>
                                </GridItem>
                                <GridItem {...styles.replaceProductInfo}>
                                    <GridItem {...styles.descriptionGridItem}>
                                        <Link
                                            {...styles.replacementProductLink}
                                            href={productDetailPath}
                                            onClick={onClick}
                                            data-test-selector="replacementProductLink"
                                        >
                                            <Typography as="h2" {...styles.productDetailDescription}>
                                                {description}
                                            </Typography>
                                        </Link>
                                    </GridItem>
                                    <GridItem {...styles.partNumbersGridItem}>
                                        {replaceProduct && (
                                            <ProductPartNumbers
                                                productNumber={replaceProduct.productNumber}
                                                customerProductNumber={replaceProduct.customerProductNumber}
                                                manufacturerItem={replaceProduct.manufacturerItem}
                                                extendedStyles={styles.partNumbersStyles}
                                            />
                                        )}
                                    </GridItem>
                                    <GridItem {...styles.productAvailibility}>
                                        <GridContainer gap={0}>
                                            <GridItem {...styles.commonGrid}>
                                                <StyledWrapper {...styles.availiblityWrapper}>
                                                    {selectProductInfo && availability && replaceProduct && (
                                                        <ProductAvailability
                                                            productId={selectProductInfo?.productId}
                                                            quantity={selectProductInfo.qtyOrdered}
                                                            productTitle={replaceProduct.productTitle}
                                                            productNumber={replaceProduct.productNumber}
                                                            trackInventory={replaceProduct?.trackInventory}
                                                            availability={availability}
                                                            unitOfMeasure={selectProductInfo?.unitOfMeasure}
                                                            isProductDetailsPage={true}
                                                            failedToLoadInventory={
                                                                selectProductInfo.failedToLoadInventory
                                                            }
                                                        />
                                                    )}
                                                </StyledWrapper>
                                            </GridItem>
                                            <GridItem {...styles.commonGrid}>
                                                <StyledWrapper>
                                                    <Link
                                                        {...styles.replacementProductLink}
                                                        href={productDetailPath}
                                                        onClick={onClick}
                                                        data-test-selector="replacementProductLink"
                                                    >
                                                        <Button
                                                            {...styles.viewReplacementBtn}
                                                            id={`View-Replacement-${replaceProduct?.id}`}
                                                        >
                                                            {translate("View Replacment")}
                                                        </Button>
                                                    </Link>
                                                </StyledWrapper>
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridItem>
                            </GridItem>
                        </Hidden>
                    </GridItem>
                ) : (
                    showDiscontinuedTag &&
                    requestForReplacement && (
                        <GridItem {...styles.replacementMssgGridItem} className="text-wrapper1">
                            <GridItem {...styles.requestReplacementGridItem} className="text-wrapper2">
                                <StyledWrapper {...styles.replacementText} className="text-wrapper3">
                                    {translate("REPLACEMENT")}
                                </StyledWrapper>
                            </GridItem>
                            <Hidden below="sm">
                                <GridItem {...styles.replaceMentMssgGridItemDesktop}>
                                    <GridItem {...styles.replacementProductInfo}>
                                        <GridContainer gap={0} {...styles.replacementProduct}>
                                            <GridItem {...styles.replacementProductGridItem}>
                                                <StyledWrapper {...styles.availiblityWrapper} className="availibility">
                                                    <Typography {...styles.replacementTextMssg}>
                                                        {siteMessage("ReplacementItemContact_Message")}
                                                    </Typography>
                                                </StyledWrapper>
                                            </GridItem>
                                            <GridItem {...styles.replacementProductButtonGridItem}>
                                                <Button {...styles.rfqButton} onClick={onButtonClickHandler}>
                                                    {translate("Request Replacement")}
                                                </Button>
                                                <Modal
                                                    headline={translate("Request Replacement")}
                                                    contentLabel="Request Replacement"
                                                    {...styles.successModal}
                                                    isOpen={isModalOpen}
                                                    handleClose={contactUsModalCloseHandler}
                                                >
                                                    <GridContainer {...styles.modalContainer}>
                                                        <GridItem {...styles.messageTextGridItem}>
                                                            <CustomContactUsForm
                                                                availability={availability}
                                                                parentModalState={continueButtonClickHandlerToParent}
                                                                productTitle={productTitle}
                                                                productNumber={productNumber}
                                                                brandName={brandName}
                                                                isRequestReplacement={true}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                </Modal>
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridItem>
                            </Hidden>
                        </GridItem>
                    )
                )}
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProduct(ProductDetailReplacement)),
    definition: {
        displayName: "Product Detail Replacement",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
